namespace Matrix.Workflow {
    export interface WorkflowStatusForm {
        StatusCode: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class WorkflowStatusForm extends Serenity.PrefixedContext {
        static formKey = 'Workflow.WorkflowStatus';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WorkflowStatusForm.init)  {
                WorkflowStatusForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = StaticTextBlock;
                var w2 = ReadOnlyDateTime;

                Q.initFormType(WorkflowStatusForm, [
                    'StatusCode', w0,
                    'Description', w0,
                    'CreatedBy', w1,
                    'CreatedWhen', w2,
                    'UpdatedBy', w1,
                    'UpdatedWhen', w2,
                    'Version', w1
                ]);
            }
        }
    }
}
